import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TransactionsTableWrapper = styled.div`
  width: 100%;

  /* Evita que TableContainer force min-height excessivo */
  > div {
    min-height: auto;
    padding-bottom: 0;
  }

  table {
    border-spacing: 0 8px;
    margin-top: 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 8px;
`;
